/**
 * Class for handling Class
 */
 class VitecHandler {

	/**
	 * Setup Method for instantiating
	 */
	static setup() {
		if (!document.querySelector('.npmv-filter-form')) {
			return;
		}

		new VitecHandler;
	}

	/**
	 * Construct for VitecHandler
	 */
	constructor() {
		// Attributes with default values
		this.defaultSortBy = 'min';
		this.filters = {
			pageNumber: 1,
		};

		// Selectors
		this.filterFormSelector = '.npmv-filter-form';
		this.clearFilterSelector = '.npmv-clear-filters';
		this.loadMoreButtonSelector = '.npmv-load-more-btn';
		this.resultObjectSelector = '.gt-result-object-item';
		this.filterFormInputSelector = this.filterFormSelector + ' input';

		// Elements used for further querying during the process of listing module
		this.listingRow = document.querySelector('.npmv-listing-row');
		this.chosenTermsRow = document.querySelector(this.filterFormSelector + ' .npmv-active-filter-choices');
		this.postsPerPage = document.querySelector('.npmv-filter-form').dataset.postsPerPage;

		this.loadMoreContainerSelector = '.npmv-load-more-container';

		// Methods
		this.parseUrl();
		this.addEventListeners();
	}

	/**
	 * Adds event listeners to module
	 * 
	 * @return {void}
	 */
	addEventListeners() {
		document.querySelectorAll(this.filterFormInputSelector).forEach(element => {
			element.addEventListener('input', this.handleInputChange.bind(this));
		});

		document.querySelector(this.clearFilterSelector).addEventListener('click', this.clearFilters.bind(this));

		const loadMoreButton = document.querySelector(this.loadMoreButtonSelector);

		if (loadMoreButton) {
			loadMoreButton.addEventListener('click', this.loadMorePosts.bind(this));
		}

	}

	/**
	 * Clear filter
	 * 
	 * @return {void}
	 */
	clearFilters() {
		document.querySelectorAll(this.filterFormInputSelector).forEach(element => {
			if (element.type === 'checkbox') {
				element.checked = false;
			}

			if (element.type === 'radio') {
				element.value === this.defaultSortBy ? element.checked = true : element.checked = false;
			}

			if (element.type === 'text') {
				element.value = ''; 
			}
		});

		this.makeAjaxRequest(this.postsPerPage, false);
	}

	/**
	 * Handles changing any input field
	 * 
	 * @param {Event} e
	 * @return {void} 
	 */
	handleInputChange(e) {
		if (e.target.classList.contains('npmv-address-search') && !this.allowSearchRequest(e.target.value.length)) {
			return;
		}

		this.filters.pageNumber = 1;
		this.makeAjaxRequest(this.postsPerPage, false);
	}

	/**
	 * Decides whether or not the length of the search term is allowed
	 * 
	 * @param {Number} length 
	 * @return {Boolean}
	 */
	allowSearchRequest(length) {
		return length !== 1 && length !== 2;
	}

	/**
	 * Loads more posts
	 * 
	 * @param {Event} e
	 * @return {void}
	 */
	loadMorePosts(e) {
		e.preventDefault();
		this.makeAjaxRequest(this.postsPerPage, true);
	}

	/**
	 * Gets what sorting is checked and replaces the label and filter accordingly
	 * 
	 * @return {void}
	 */
	 setSortingFilter() {
		const sortSelection = document.querySelector('input[name="npmv_sort"]:checked');
		const chosenSort = document.querySelector('.npmv-sorting-label span');
		this.filters.sortBy = sortSelection.value;

		chosenSort.innerHTML = sortSelection.closest('.npmv-sorting-item').querySelector('label').innerHTML;
	}

	/**
	 * Gets the value of the text inputs and sets the filter accordingly
	 * 
	 * @return {void}
	 */
	setTextInputFilter() {
		this.filters.smallSizeInput = document.querySelector(this.filterFormSelector + ' .npmv-small-size').value;
		this.filters.bigSizeInput = document.querySelector(this.filterFormSelector + ' .npmv-big-size').value;
		this.filters.addressSearch = document.querySelector(this.filterFormSelector + ' .npmv-address-search').value;
	}

	/**
	 * Gets the selected checkboxes and populates the filter accordingly
	 * 
	 * @return {void}
	 */
	setCheckboxFilters() {
		this.filters.areaIds = [];
		this.filters.typeIds = [];

		const selections = document.querySelectorAll(this.filterFormInputSelector + '[type="checkbox"]');

		selections.forEach(element => {
			const termId = element.value;
			const termName = element.dataset.termName;
			const chosenTermLabel = this.chosenTermsRow.querySelector('label[for="npmv-checkbox-' + termId + '"]');

			if (element.checked) {
				if (element.closest('.gt-filter-field').classList.contains('npmv-area-choices')) {
					this.filters.areaIds.push(element.value);
				}

				if (element.closest('.gt-filter-field').classList.contains('npmv-type-choices')) {
					this.filters.typeIds.push(element.value);
				} 

				if (chosenTermLabel) {
					chosenTermLabel.remove();
				}	

				this.chosenTermsRow.appendChild(this.getLabelElement(termId, termName));
			} else {
				if (chosenTermLabel) {
					chosenTermLabel.remove();
				}
			}
		});
	}

	/**
	 * Runs set methods for the filters
	 * 
	 * @param {Boolean} fetchMore
	 * @return {void}
	 */
	setFilters(fetchMore = false) {
		this.setSortingFilter();
		this.setTextInputFilter();
		this.setCheckboxFilters();

		if (fetchMore) {
			this.filters.pageNumber++;
		}
	}

	/**
	 * Fetches posts to display
	 * 
	 * @param {Number} postsPerPage 
	 * @param {Boolean} fetchMore 
	 */
	makeAjaxRequest(postsPerPage, fetchMore = false) {
		this.listingRow.classList.add('loader');

		this.setFilters(fetchMore);
		this.updateUrl();

		const data = new FormData;
        data.append('action', 'npmv_object_listing');
        data.append('security', Nordicpm_Vitec_Vars.security); // eslint-disable-line camelcase
		data.append('postsPerPage', postsPerPage);
		data.append('pageNumber', this.filters.pageNumber);
		data.append('areaIds', this.filters.areaIds);
		data.append('typeIds', this.filters.typeIds);
		data.append('smallSize', this.filters.smallSizeInput);
		data.append('bigSize', this.filters.bigSizeInput);
		data.append('addressSearch', this.filters.addressSearch);
		data.append('sortBy', this.filters.sortBy);

        fetch(Nordicpm_Vitec_Vars.ajax_url, { // eslint-disable-line camelcase
            method: 'POST',
            credentials: 'same-origin',
            body: data,
            contentType: 'application/json'
        })
        .then((response) => response.json())
        .then((data) => {
			this.listingRow.classList.remove('loader');
			console.log(data);
            if (data.success) {
				const postsHTML = data.posts;
				this.listingRow.innerHTML = fetchMore ? this.listingRow.innerHTML + postsHTML : postsHTML;
				this.maybeRemoveLoadMoreContainer(data.no_more_posts);
            } else {
				this.listingRow.innerHTML = '<h5 class="npmv-no-objects-found">' + data.error_message + '</h5>';
            }

			document.querySelector('.gt-filter-result-text span').innerHTML = data.found_posts; // eslint-disable-row

			if (this.hasModifiedPostsPerPage) {
				this.resetPostsPerPageModification();
			}
        });
	}

	/**
	 * Maybe remove load more container
	 * 
	 * @param {Boolean} noMorePosts 
	 * @return {void}
	 */
	maybeRemoveLoadMoreContainer(noMorePosts) {
		if (noMorePosts) {
			document.querySelector(this.loadMoreContainerSelector).classList.add('npmv-hidden');
			return;
		}

		document.querySelector(this.loadMoreContainerSelector).classList.remove('npmv-hidden');
	}

	/**
	 * Resets the page number, posts per page and has modified posts per page boolean
	 * 
	 * @return {void}
	 */
	resetPostsPerPageModification() {
		this.hasModifiedPostsPerPage = false;
		this.updateUrl();
	}

	/**
	 * Calculates how many posts is fetched on load and sets a new appropriate page number to filter object
	 * Also saves the old postsPerPage as defaultPostsPerPage for use in the resetPostsPerPageModification Method
	 * 
	 * @param {Number} pageNumber 
	 */
	setPageNumberModification(pageNumber) {
		this.hasModifiedPostsPerPage = true;
		this.pageNumberQueryArg = parseInt(pageNumber);

		this.postsOnPageLoad = this.pageNumberQueryArg * parseInt(this.postsPerPage);
		this.filters.pageNumber = this.postsOnPageLoad / this.postsPerPage;
	}

	/**
	 * Creates a label element with proper classes, ids and content and returns it 
	 * 
	 * @param {Number} termId 
	 * @param {String} termName 
	 * @return {HTMLElement}
	 */
	getLabelElement(termId, termName) {
		const labelElement = document.createElement('label');
		labelElement.classList.add('gt-filter-tag', 'chosen-tag');
		labelElement.setAttribute('for', 'npmv-checkbox-' + termId);
		labelElement.innerHTML = termName;

		return labelElement;
	}

	/**
	 * Populates input fields from query string
	 * 
	 * @return {void}
	 */
	parseUrl() {
		const searchParamsArray = new URLSearchParams(window.location.search).toString().split('&');

		searchParamsArray.forEach(param => {
			const key = param.split('=')[0];

			// Forceing array because multiple areaIds won't affect single indexed values
			const value = decodeURIComponent(param.split('=')[1]).split(','); 

			if (key === 'pageNumber') {
				this.setPageNumberModification(parseInt(value));
			}

			const fieldSelector = this.getFilterFieldSelector(key);
			const selectorMethod = this.getSelectorMethod(key);
			
			const results = document[selectorMethod](fieldSelector);

			if (!results) {
				return;
			}

			if (this.isIterable(results)) {
				results.forEach(element => {
					if (!value.includes(element.value)) {
						return;
					}

					element.checked = true;
				});
			} else {
				results.value = value;
			}
		});

		this.setFilters();
	}

	/**
	 * Takes an object and checks if the object is iterable
	 * In practice it means if the object is a single HTML Element or a NodeList
	 * 
	 * @param {Object} object 
	 * @return {Boolean}
	 */
	isIterable(object) {
		if (object === null || object === undefined) {
			return false;
		}

		return typeof object[Symbol.iterator] === 'function';
	}

	/**
	 * Get CSS Selector for given filter key
	 * 
	 * @param {String} filterKey 
	 * @return {String}
	 */
	getFilterFieldSelector(filterKey) {
		switch (filterKey) {
			case 'smallSizeInput':
				return '.npmv-small-size';
			case 'bigSizeInput':
				return '.npmv-big-size';
			case 'areaIds':
				return '.npmv-filter-item-vitec_object_area input';
			case 'typeIds':
				return '.npmv-filter-item-vitec_object_type input';
			case 'addressSearch':
				return '.npmv-address-search';
			case 'sortBy':
				return '.npmv-sorting-item input[name="npmv_sort"]';
		}
	}


	/**
	 * Get querySelector Method to run by given filterKey
	 * 
	 * @param {String} filterKey 
	 * @return {String}
	 */
	getSelectorMethod(filterKey) {
		if (['areaIds', 'typeIds', 'sortBy'].includes(filterKey)) {
			return 'querySelectorAll';
		}

		return 'querySelector';
	}

	/**
	 * Updates the URL based off the filter object
	 * 
	 @return {void}
	 */
	updateUrl() {
		const emptyValues = [];
		const search = new URLSearchParams(this.filters);
		const filterArray = search.toString().split('&');

		filterArray.forEach(filter => {
			const key = filter.split('=')[0];
			const value = filter.split('=')[1];
			if (value === '') {
				emptyValues.push(key);
			}
		});

		for (let i = 0; i < emptyValues.length; ++i) {
			search.delete(emptyValues[i]);
		}

		if (search.get('pageNumber') === '1') {
			search.delete('pageNumber');
		}

		if (search.get('sortBy') === this.defaultSortBy) {
			search.delete('sortBy');
		}
	
		const pushStateUrl = search.toString() ? '?' + search.toString() : location.href.split('?')[0];
		history.pushState({}, null, pushStateUrl);
	}
}

// Wait for DOM to be interactive
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	VitecHandler.setup();
} else {
	document.addEventListener('DOMContentLoaded', VitecHandler.setup);
}